import React, { createContext, useContext, useEffect, useState } from 'react';

const AdminPeriodContext = createContext({ period: 'day' });
const STORAGE_KEY = 'correfood_admin_period';

export function AdminPeriodProvider({ children }) {
  const [period, setPeriod] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored || 'day';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, period);
  }, [period]);

  return (
    <AdminPeriodContext.Provider value={{ period, setPeriod }}>
      {children}
    </AdminPeriodContext.Provider>
  );
}

export function useAdminPeriod() {
  return useContext(AdminPeriodContext);
}
